import * as React from 'react'
import { ReactElement } from 'react'
import { EntityComboboxProps } from './EntityCombobox'
import useAuthorizationGroups from '../../hooks/useAuthorizationGroups'
import BaseCombobox from './BaseCombobox'

export type AuthorizationGroupDto = {
    id: string
    name: string
}

type Props = Partial<EntityComboboxProps<AuthorizationGroupDto>> &
    Required<Pick<EntityComboboxProps<AuthorizationGroupDto>, 'selectedOptions' | 'onOptionSelect'>>

export default function AuthorizationGroupCombobox(props: Props): ReactElement {
    const { authorizationGroups } = useAuthorizationGroups()

    return (
        <BaseCombobox<AuthorizationGroupDto>
            entities={authorizationGroups}
            alphabetical
            getEntityLabel={group => group.name}
            getEntityValue={group => group.id}
            placeholderKey={'base.authorizationgroupcombobox.placeholder'}
            {...props}
        />
    )
}
